var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333333 4.2333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.1167658,0.32069977 A 2.116653,1.6427755 0 0 0 3.6669902e-8,1.9634909 2.116653,1.6427755 0 0 0 0.26178105,2.7502793 L 0.09463163,3.642234 A 0.22796543,0.22796543 0 0 0 0.393193,3.9000888 L 1.4772957,3.5261166 A 2.116653,1.6427755 0 0 0 2.1167658,3.6062828 2.116653,1.6427755 0 0 0 4.2333333,1.9634909 2.116653,1.6427755 0 0 0 2.1167658,0.32069977 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.3eb85586ae6057d20da0c07074fb7c6c.svg";
export { ForwardRef as ReactComponent };